(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function updateCountdown(root) {
    var countdownRoot = root.querySelector('[data-countdown-root]');
    if (!countdownRoot) return;

    var endRaw = root.getAttribute('data-countdown-end');
    if (!endRaw) return;

    var endTime = new Date(endRaw).getTime();
    if (Number.isNaN(endTime)) return;

    var expiredText = root.getAttribute('data-expired-text') || '00';

    function render() {
      var now = Date.now();
      var diff = Math.max(0, endTime - now);

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      var daysEl = countdownRoot.querySelector('[data-unit="days"]');
      var hoursEl = countdownRoot.querySelector('[data-unit="hours"]');
      var minutesEl = countdownRoot.querySelector('[data-unit="minutes"]');
      var secondsEl = countdownRoot.querySelector('[data-unit="seconds"]');

      if (diff === 0) {
        if (daysEl) daysEl.textContent = expiredText;
        if (hoursEl) hoursEl.textContent = expiredText;
        if (minutesEl) minutesEl.textContent = expiredText;
        if (secondsEl) secondsEl.textContent = expiredText;
        return;
      }

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    render();
    window.setInterval(render, 1000);
  }

  function init(root) {
    if (!root || root.dataset.eofyBannerInit === 'true') return;
    root.dataset.eofyBannerInit = 'true';
    updateCountdown(root);
    root.querySelector('.eofy-banner__button').addEventListener('click', function (e) {
      e.preventDefault();
      if (document.querySelector(".eofy-tier")) {
        document.querySelector(".eofy-tier").scrollIntoView({ behavior: 'smooth', block: "center" });
      } else {
        document.querySelector(".eofy-rewards__inner").scrollIntoView({ behavior: 'smooth', block: "center" });

      }

    });
  }

  function boot() {
    document.querySelectorAll('eofy-banner').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('eofy-banner');
    if (root) init(root);
  });
})();
